// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseChip_root__2LfRz","iconContainer":"BaseChip_iconContainer__2K5Mv","icon":"BaseChip_icon__3PihX"};